import type { TabStructure } from "./buildTabsFromMeta";

/**
 * Check if a tab has any visible fields based on already-computed visibility
 * 
 * This is a "dumb" utility that reuses visibleFieldNames from useFieldDependencies.
 * It does NOT re-evaluate dependencies to avoid drift from the single source of truth.
 * 
 * @param tab - Tab structure to check
 * @param visibleFieldNames - Set of visible field names (from useFieldDependencies)
 * @returns true if tab has at least one visible field
 */
export function tabHasVisibleFields(
  tab: TabStructure,
  visibleFieldNames: Set<string>
): boolean {
  // Check if any field in any section/column is visible
  for (const section of tab.sections) {
    // Widget sections have no columns/fields but must still show
    // They are rendered by ShopifyStyleRenderer based on _widgetId
    const hasWidgetId = !!(section as any)._widgetId;
    
    if (hasWidgetId) {
      return true;
    }

    for (const column of section.columns) {
      if (column.fields.some(field => visibleFieldNames.has(field.fieldname))) {
        return true;
      }
    }
  }

  return false;
}

